// Source/Facts-Slider/Component.ts
import { Swiper } from "Swiper";
class Facts_Slider extends HTMLElement {
  swiper;
  connectedCallback() {
    if (!this.shadowRoot)
      this.#attachTemplate();
    const { $pagination, $next, $prev } = this;
    this.swiper = new Swiper(this.$swiper, {
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      pagination: {
        clickable: true,
        el: $pagination
      }
    });
  }
  disconnectedCallback() {
    this.swiper.destroy();
  }
  #attachTemplate() {
    const template = this.querySelector(`template[shadowrootmode='open']`);
    if (!template)
      return;
    const fragment = template.content.cloneNode(true);
    const shadow = this.attachShadow({ mode: "open" });
    shadow.append(fragment);
  }
  get root() {
    return this.shadowRoot;
  }
  get $swiper() {
    return this.root.querySelector(`.swiper`);
  }
  get $pagination() {
    return this.root.querySelector(`.swiper-pagination`);
  }
  get $next() {
    return this.root.querySelector(`.swiper-button-next`);
  }
  get $prev() {
    return this.root.querySelector(`.swiper-button-prev`);
  }
}

// Source/Facts-Slider/mod.ts
customElements.define("facts-slider", Facts_Slider);
